import { STATE_VERSION, STORAGE_KEY } from '../constants.js'

export function isValidStoredState(value) {
  return Boolean(value && value.version === STATE_VERSION && typeof value.stage === 'string' && value.observations && typeof value.observations === 'object' && value.feedback && typeof value.feedback === 'object')
}

export function loadStoredState(storage = globalThis.localStorage) {
  if (!storage) return null
  try {
    const raw = storage.getItem(STORAGE_KEY)
    if (!raw) return null
    const value = JSON.parse(raw)
    if (!isValidStoredState(value)) {
      storage.removeItem(STORAGE_KEY)
      return null
    }
    return value
  } catch {
    storage.removeItem(STORAGE_KEY)
    return null
  }
}

export function saveStoredState(state, storage = globalThis.localStorage) {
  if (!storage) return
  storage.setItem(STORAGE_KEY, JSON.stringify(state))
}

export function clearStoredState(storage = globalThis.localStorage) {
  storage?.removeItem(STORAGE_KEY)
}

